<template></template>

<script>
export default {
  name: "profile",
  mounted() {
    this.$router.replace({
      name: "personnel-show",
      params: { id: this.$auth.user().id },
    });
  },
};
</script>

<style>
</style>